import * as qs from 'qs'

const getCreateWorkspaceLink = ({ step } = {}) => {
  const query = qs.stringify({ step })
  return `/workspace/create${query ? `?${query}` : ''}`
}

export { getCreateWorkspaceLink }
